






























































import { Component, Vue, Prop } from 'vue-property-decorator'
import { passwordValidator, checkPasswordValidator, phoneNumberValidator, usernameValidator, nameValidator, partValidator } from '../../utils/validator'
import SelectRegion from '@/components/Select/SelectRegion.vue'
import api from '../../api'
import { UserModule } from '../../store/modules/user'
@Component({
  components: {
    SelectRegion,
  },
})
export default class CreateDepartment extends Vue {
  private showDialog: boolean = false
  private submitLoading: boolean = false
  private isModify: boolean = false
  private formData: any = {
    name: '',
    netList: [],
    type: false,
  }
  private rules = {
    name: [{ validator: partValidator, required: true, trigger: 'blur' }],
  }

  public show(formData?: any) {
    if (formData) {
      console.log(formData);
      let type=formData.qrcodeId.substring(0,1)== '0' ? true:false
      
      this.isModify = true 
      let netlistxx=[]
      if(formData.netList){
        // netlistxx=formData.netList.split('#')
        for(let i=0;i<formData.netList.length;i++){
          let obj=formData.netList[i].split("#")
          netlistxx.push(obj)
        }
      }
     
      

      this.formData = {
        ...formData,
        name: formData.deptName,
        netId: formData.netId || '',
        netList:netlistxx,
        type:type
        
      }
    } else {
      this.isModify = false
    }
    this.showDialog = true
  }
   public show2(formData?: any,netlist?: any[]) {
    if (formData) {
      console.log(formData);
      console.log(netlist);
      
      let type=formData.qrcodeId.substring(0,1)== '0' ? true:false
      
      this.isModify = true
      this.formData = {
        ...formData,
        name: formData.deptName,
        netId: formData.netId || '',
        type:type
        
      }
    } else {
      this.isModify = false
    }
    this.showDialog = true
  }
  public cancel() {
    this.formData = {
      name: '',
      netId: '',
    }
    this.showDialog = false
    if ((this.$refs as any).dialogForm) {
      (this.$refs as any).dialogForm.clearValidate()
    }
  }
  private processData(inputData) {
  const result = {};
  for (const item of inputData) {
    const netId = item[3];
    const groupId = item[4];
    if (!result[netId]) {
      result[netId] = { netId, groupId: [] };
    }
    if (groupId && !result[netId].groupId.includes(groupId)) {
      result[netId].groupId.push(groupId);
    }
  }
  return Object.values(result);
  }
  public submitForm(refName: string) {
    (this.$refs as any)[refName].validate().then(() => {
      const { name = '', netList = [], deptId = '', deptName = '' } = this.formData || {}
      console.log( this.formData);
      console.log(netList);
      
      
      this.submitLoading = true
      if (this.isModify) {
        api.modifyDepartment({
          type: this.formData.type ? 0 : 1,
          // netIds: netList.map((net: any[]) => net[net.length - 1]),
          netIdGroupIdList: this.processData(netList),

          deptId,
          deptName:name,
          orgId: UserModule.orgInfo.orgId,
        }).then(() => {
          this.$message.success('修改成功')
          this.cancel()
          this.$emit('success')
        }).finally(() => {
          this.submitLoading = false
        })
      } else {
        api.addDepartment({
          type: this.formData.type ? 0 : 1,
          name: name,
          father: '0',
          orgId: UserModule.orgInfo.orgId,
          // netIds: netList.map((net: any[]) => net[net.length - 1]),
                    netIdGroupIdList: this.processData(netList),
        }).then((data: any) => {
          this.$message.success('添加部门成功')
          this.cancel()
          this.$emit('success')
        }).finally(() => {
          this.submitLoading = false
        })
      }
    })
  }
}
